import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

const getAssignedClients = async () => {
  const response = await Axios.get(
    API_URL + "/CarePlanWizard/getassignedClients",
  );
  return response;
};

const getAssignedClientProfile = async (clientId) => {
  const response = await Axios.get(
    API_URL + `/CarePlanWizard/get-client-profile/${clientId}`,
  );
  return response;
};

const getClients = async (filters) => {
  const response = await Axios.post(
    API_URL + "/CarePlanWizard/searchclients",
    filters,
  );
  return response;
};

const updateClientNote = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizard/SaveCarePlanClientComment`,
    data,
  );
  return response.data;
};

export {
  getAssignedClients,
  getAssignedClientProfile,
  getClients,
  updateClientNote,
};
